export const LOTTERY_INFO_ITEM = "ltr_nonclub";
export const LOTTERY_NEW_CODE_IDS_ITEM = "ltr_new_code_ids";
export const LOTTERY_WAITING_FOR_CODES_ITEM = "ltr_waiting_for_codes";

export const LOTTERY_START_TIME = new Date("2025-01-13").setHours(0, 0, 0, 0);
export const LOTTERY_END_TIME = new Date("2025-04-07").setHours(23, 59, 59, 999);
